import React, { useEffect, useState } from 'react'
import { Card, CardContent } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { get } from 'lodash'
import { Divider } from '@mui/material'
import { COLORS } from 'src/utils/Themes/colors'
import Modal from 'src/components/common/Modal'
import AllRenewals from 'src/components/RiskReports/UpComingRenewals/AllRenewals'
import { RISK_REPORTS } from 'src/utils/constants/RiskReports'
import formatDate from 'src/utils/commonMethods/formatDate'
import formatToINR from 'src/utils/commonMethods/formatToINR'

const UpcomingHealthRenewals = ({
  data,
  aggregatedPolicies,
  ClientId,
  insuranceName,
}) => {
  const classes = useStyles()
  const [modalOpen, setModalOpen] = useState(false)
  const [upcomingRenewals, setUpcomingRenewals] = useState([])
  const [cutoffRenewals, setCutoffRenewals] = useState([])

  const closeModal = () => {
    setModalOpen(false)
  }

  const handleViewAll = () => {
    setModalOpen(true)
  }

  useEffect(() => {
    if (data) {
      setUpcomingRenewals(data)
      setCutoffRenewals(data?.slice(0, 2))
    }
  }, [data])

  return (
    <>
      <div className={classes.upcomingRenewalsWrapper}>
        {modalOpen ? (
          <Modal
            bgcolor={COLORS?.WHITE}
            class={classes.modalRoot}
            ordered={modalOpen}
            width={'90%'}
            left={'5%'}
            top={'5%'}
            modelClosed={closeModal}
          >
            <div className={classes.modalContent}>
              <AllRenewals
                data={upcomingRenewals}
                aggregatedPolicies={aggregatedPolicies}
                closeModal={closeModal}
                ClientId={ClientId}
                insuranceName={insuranceName}
              />
            </div>
          </Modal>
        ) : null}
        <Card classes={{ root: classes.root }}>
          <CardContent classes={{ root: classes.contentRoot }}>
            <div className={classes.renewalsItemWrapper}>
              <div className={classes.renewalsContent}>
                <div className={classes.legend}>
                  <span className={classes.legendTitle}>Renewals</span>
                  <p
                    id='viewAll'
                    aria-hidden='true'
                    onClick={handleViewAll}
                    className={classes.viewAll}
                  >
                    {RISK_REPORTS?.VIEW_ALL}
                  </p>
                </div>
                {cutoffRenewals?.map((item, index) => {
                  const iconUrl = get(item, 'productImage', '')
                  const title = get(item, 'insuranceType', '')
                  const expDate = get(item, 'expiresOn', '')
                  const premiumPaid = get(item, 'premiumAmount.text', 0)
                  if (index < 1) {
                    return (
                      <div
                        key={`renewals-${index}`}
                        className={classes.renewalsItem}
                      >
                        <div className={classes.icon}>
                          <img src={iconUrl} alt='title' />
                        </div>
                        <div className={classes.contentContaainer}>
                          <div>
                            <div className={classes.title}>{title}</div>
                          </div>
                          <Divider className={classes.horizontalDivider} />
                          <div className={classes.subTextContainer}>
                            <div className={classes.expDate}>
                              <span className={classes.expiredText}>
                                {RISK_REPORTS?.EXPIRED}
                              </span>
                              : <br />
                              <span className={classes.expDateColumn}>
                                {expDate ? formatDate(expDate) : ''}
                              </span>
                            </div>
                            <div className={classes.premiumPaid}>
                              PremiumPaid
                              <div className={classes.amt}>
                                {formatToINR(premiumPaid)}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  }
                })}
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  )
}

export default UpcomingHealthRenewals

const useStyles = makeStyles({
  upcomingRenewalsWrapper: {
    marginTop: '0px',
  },
  root: {
    borderRadius: '10px',
  },
  contentContaainer: {
    display: 'flex',
    flexDirection: 'column',
    // marginLeft: "1%",
    marginTop: '35px',
  },
  subTextContainer: {
    display: ' flex',
  },
  expiredText: {
    marginLeft: '-45px',
  },
  expDateColumn: {
    fontWeight: '600',
  },
  renewalsItemWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '136px',
    overflow: 'hidden',
  },
  contentRoot: {
    padding: 0,
    '&:last-child': {
      padding: 0,
    },
  },
  legend: {
    // maxWidth: "100vw",
    // flexShrink: 0,
    // flexBasis: "150px",
    height: '50px',
    marginTop: '-20px',
    background: COLORS.DARK_PINK,
    display: 'flex',
    // flexDirection: "column",
    // justifyContent: "center",
    alignItems: 'center',
  },
  legendTitle: {
    fontSize: '17px',
    lineHeight: '24px',
    color: COLORS.WHITE,
    fontWeight: 600,
    textAlign: 'center',
    paddingRight: '36%',
    marginLeft: '20px',
  },
  viewAll: {
    textDecoration: 'underline',
    fontSize: '13px',
    color: COLORS.LINK_COLOR_LIGHT,
    // marginTop: "20px",
    marginBottom: '0px',
    marginLeft: '5%',
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'none',
    },
  },
  renewalsContent: {
    width: '100%',
    flexGrow: 1,
  },
  renewalsItem: {
    borderBottom: `0.7px solid ${COLORS.GREY_11}`,
    display: 'flex',
    alignItems: 'center',
    height: '50px',
    // justifyContent: "space-between",
    padding: '9px 10px',
    '&:last-child': {
      borderBottom: '0px solid',
    },
  },
  icon: {
    width: '30px',
    marginLeft: '10px',
    marginRight: '15px',
    marginTop: '10px',
    '& img': {
      maxWidth: '100%',
    },
  },
  title: {
    fontSize: '13px',
    lineHeight: '18px',
    margin: '0 0 0 0',
    color: COLORS.GREY,
    flexBasis: '145px',
    // maxWidth: "145px",
    flexShrink: 0,
    fontWeight: '600',
    float: 'left',
  },
  expDate: {
    fontSize: '12px',
    margin: '0 0px 0 0',
    color: COLORS.GREY_10,
    // flexBasis: "116px",
    // flexShrink: 0,
  },
  premiumPaid: {
    fontSize: '11px',
    color: COLORS.GREY_10,
    flexGrow: 1,
    textAlign: 'end',
  },
  amt: {
    color: COLORS.GREY,
    fontSize: '13px',
    fontWeight: '600',
    // marginTop: "3px",
  },
  modalRoot: {
    height: '90%',
    overflow: 'auto',
  },
  modalContent: {
    textAlign: 'center',
    padding: '0px 24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
    margin: '24px 0px',
    boxSizing: 'border-box',
  },
  horizontalDivider: {
    width: '15vw',
    margin: '2% 0% 3% 0%',
    backgroundColor: COLORS.DARK_GREY,
  },
})
